export default "__VITE_ASSET__B36MgGQP__"